import { css } from "@linaria/core";
import type { Colors } from "./colors";
import {
  rawFonts,
  rawFontSizes,
  rawLetterSpacings,
  rawLineHeights,
  type Fonts,
  type FontSizes,
  type LetterSpacings,
  type LineHeights,
} from "./fonts";
import { createCSSValues } from "./utils/css-values";
import { createCSSVariables } from "./utils/css-variables";
import { CSS_VARIABLE_PREFIXES } from "./config";
import { rawColors, rawSemanticColors } from "./colors";
import type { Shadows } from "./shadows";
import { shadows as shadowValues } from "./shadows";
import type { Spacings } from "./spacings";
import { spacings as spacingValues } from "./spacings";

const colors = createCSSValues<Colors>({
  ...rawColors,
  ...rawSemanticColors,
});

const fontSizes = createCSSValues<FontSizes>(rawFontSizes, CSS_VARIABLE_PREFIXES.FONT_SIZE_PREFIX);
const fonts = createCSSValues<Fonts>(rawFonts, CSS_VARIABLE_PREFIXES.FONT_PREFIX);

const lineHeights = createCSSValues<LineHeights>(
  rawLineHeights,
  CSS_VARIABLE_PREFIXES.LINE_HEIGHT_SPACING,
);

const letterSpacings = createCSSValues<LetterSpacings>(
  rawLetterSpacings,
  CSS_VARIABLE_PREFIXES.LETTER_SPACING_PREFIX,
);

const shadows = createCSSValues<Shadows>(shadowValues);

const spacings = createCSSValues<Spacings>(spacingValues, CSS_VARIABLE_PREFIXES.SPACING_PREFIX);

// NOTE: For now, we will not wrap current app inside another element,
// so we using :global() {} to decorelate css from a styled-component.
// eslint-disable-next-line @typescript-eslint/no-unused-expressions
css`
  :global() {
    :root {
      ${createCSSVariables(colors.raw, CSS_VARIABLE_PREFIXES.COLOR)};
      ${createCSSVariables(fonts.raw, CSS_VARIABLE_PREFIXES.FONT_PREFIX)};
      ${createCSSVariables(fontSizes.raw, CSS_VARIABLE_PREFIXES.FONT_SIZE_PREFIX)};
      ${createCSSVariables(lineHeights.raw, CSS_VARIABLE_PREFIXES.LINE_HEIGHT_SPACING)};
      ${createCSSVariables(letterSpacings.raw, CSS_VARIABLE_PREFIXES.LETTER_SPACING_PREFIX)};
      ${createCSSVariables(shadows.raw, CSS_VARIABLE_PREFIXES.SHADOW)};
      ${createCSSVariables(spacings.raw, CSS_VARIABLE_PREFIXES.SPACING_PREFIX)}
    }
  }
`;

export { colors, fonts, fontSizes, lineHeights, letterSpacings, shadows, spacings };
